module.exports = __webpack_public_path__ + "img/outside.b1da7802.png";